import { MRT_TableInstance } from "mantine-react-table";
import { useEffect } from "react";

// Chân bảng cách đáy màn hình đúng bằng padding "md" của AppShell.Main,
// để trang vừa khít màn hình, không sinh thanh cuộn
const BOTTOM_GAP = 16;

// Màn hình thấp quá thì vẫn giữ bảng đủ dùng, chấp nhận trang cuộn
const MIN_HEIGHT = 300;

// Đặt chiều cao vùng cuộn của bảng sao cho chân bảng (thanh phân trang) nằm sát đáy màn hình.
// Đo vị trí thật của bảng thay vì trừ hằng số, vì vùng filter phía trên đổi chiều cao
// theo độ rộng màn hình (ô filter xuống dòng)
export const useTableFillScreen = (
  table: MRT_TableInstance<any>,
  setHeight: (height: number) => void,
) => {
  useEffect(() => {
    const update = () => {
      const container = table.refs.tableContainerRef.current;
      const paper = table.refs.tablePaperRef.current;
      if (!container || !paper) return;

      const containerRect = container.getBoundingClientRect();
      // Phần khung bảng nằm dưới vùng cuộn: thanh phân trang và viền
      const belowContainer =
        paper.getBoundingClientRect().bottom - containerRect.bottom;
      const top = containerRect.top + window.scrollY;

      setHeight(
        Math.max(
          MIN_HEIGHT,
          Math.floor(window.innerHeight - BOTTOM_GAP - top - belowContainer),
        ),
      );
    };

    update();
    // Đo lại khi bố cục phía trên đổi chiều cao (filter xuống dòng, đổi kích thước cửa sổ)
    const observer = new ResizeObserver(update);
    observer.observe(document.body);
    window.addEventListener("resize", update);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", update);
    };
  }, [table, setHeight]);
};
